export class Radio {
  constructor(difference) {
    this.singleTabs = true
    ;(this.width = 280), (this.height = 40), (this.left = 0), (this.top = 0), (this.value = "选项1")
    this.innerElement = "cxRadio"
    ;(this.fontFamily = "sans-serif"),
      (this.hoverFontFamily = "sans-serif"),
      (this.fontSize = 16),
      (this.hoverFontSize = 16),
      (this.fontWeight = 400),
      (this.hoverFontWeight = 400),
      (this.color = "rgba(0,0,0,1)"),
      (this.textIsThemeColor = false),
      (this.hoverColor = "rgba(0,0,0,1)"),
      (this.hoverTextIsThemeColor = false),
      (this.bgColor = "rgba(255,255,255,0)"),
      (this.hoverBgColor = "rgba(255,255,255,0)"),
      (this.lineHeight = 40),
      (this.hoverLineHeight = 40),
      (this.letterSpacing = 0),
      (this.hoverLetterSpacing = 0),
      (this.fontStyle = "normal"),
      (this.hoverFontStyle = "normal"),
      (this.textAlign = "left"),
      (this.hoverTextAlign = "left"),
      (this.writingMode = "horizontal-tb"),
      (this.hoverWritingMode = "horizontal-tb"),
      (this.textDecoration = "none"),
      (this.hoverTextDecoration = "none"),
      (this.textIndent = 0),
      (this.hoverTextIndent = 0),
      (this.borderTopLeftRadius = 0),
      (this.borderTopRightRadius = 0),
      (this.borderBottomLeftRadius = 0),
      (this.borderBottomRightRadius = 0),
      (this.borderColor = "#000000"),
      (this.borderStyle = "solid"),
      (this.borderWidth = 0)
    ;(this.borderIsThemeColor = false),
      (this.hoverBorderColor = "#000000"),
      (this.hoverBorderStyle = "solid"),
      (this.hoverBorderWidth = 0),
      (this.hoverBorderIsThemeColor = false),
      (this.activeIndex = 0),
      (this.radioLists = [
        {
          name: "选项1",
          content: "选项1"
        },
        {
          name: "选项2",
          content: "选项2"
        },
        {
          name: "选项3",
          content: "选项3"
        }
      ]),
      (this.bgColorIsThemeColor = false),
      (this.hoverBgColorIsThemeColor = false),
      (this.opacity = 100)
    this.bgType = "纯色" //纯色 线性渐变 径向渐变
    this.bgStartColor = "rgba(23,241,255,1)"
    this.bgEndColor = "rgba(23,116,255,1)"
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.iconPosition = "left" // left,right
    this.iconSrc1 = ""
    this.iconType1 = "img" // img,icon 图片和字体图标
    this.iconWidth = 14
    this.iconMargin = 10
    this.iconColorIsThemeColor = false
    this.iconColor = "#333"
    this.iconSrc2 = ""
    this.iconType2 = "img" // img,icon 图片和字体图标
    this.marginRight = 20
    this.itemPadding = 0 // 切换项间距
    this.itemPaddingTop = 0
    this.itemPaddingRight = 0
    this.itemPaddingLeft = 0
    this.itemPaddingBottom = 0
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
